import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Sheet } from '../kit/Sheet';
import { Button } from '../kit/Button';
import { enablePush } from '../../lib/fcm';
import { markPushOnboarded } from '../../lib/push-onboarding';
import { haptic } from '../../lib/haptic';

type Props = {
  open: boolean;
  onClose: () => void;
};

export function PushPermissionPrompt({ open, onClose }: Props) {
  const { t } = useTranslation('common');
  const [busy, setBusy] = useState(false);

  const finish = () => {
    markPushOnboarded();
    onClose();
  };

  const handleEnable = async () => {
    if (busy) return;
    setBusy(true);
    haptic.tap();
    try {
      await enablePush();
    } catch {
      // Outcome (granted/denied/default) is handled by markPushOnboarded —
      // we don't want to re-prompt on next submit regardless of the result.
    } finally {
      setBusy(false);
      finish();
    }
  };

  return (
    <Sheet open={open} onClose={finish} title={t('push.title')}>
      <div data-theme="light" className="space-y-4">
        <p className="text-sm text-[var(--color-text-secondary)]">
          {t('push.body')}
        </p>
        <Button onClick={handleEnable} loading={busy} disabled={busy}>
          {busy ? t('push.busy') : t('push.enable')}
        </Button>
        <Button variant="ghost" onClick={finish} disabled={busy}>
          {t('push.notNow')}
        </Button>
      </div>
    </Sheet>
  );
}
